export default function Footer () {
  return (
    <footer className='bg-gray-900 text-white py-12'>
      <div className='container mx-auto px-4'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 mb-8'>
          <div className='md:col-span-2'>
            <img
              src='https://legacytelecom.net.br/wp-content/uploads/2024/08/legacylogo.png'
              alt='Legacy Telecom'
              className='h-12 w-auto mb-4'
            />
            <p className='text-gray-400 mb-4 max-w-md'>
              Internet fibra óptica de alta velocidade para conectar você ao
              futuro. Tecnologia avançada, preços justos e atendimento
              excepcional.
            </p>
            <div className='flex space-x-4'>
              <a
                href='#'
                className='w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors cursor-pointer'
              >
                <i className='ri-facebook-fill'></i>
              </a>
              <a
                href='#'
                className='w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors cursor-pointer'
              >
                <i className='ri-instagram-line'></i>
              </a>
              <a
                href='http://wa.me/556540420692'
                className='w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors cursor-pointer'
              >
                <i className='ri-whatsapp-line'></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className='text-lg font-semibold mb-4'>Atendimento</h3>
            <ul className='space-y-2'>
              <li className='text-gray-400'>
                <i className='ri-phone-line mr-2'></i>
                (65) 4042-0692
              </li>
              <li className='text-gray-400'>
                <i className='ri-mail-line mr-2'></i>
                suporte@legacytelecom.net.br
              </li>
              <li>
                <a
                  href='https://ixc.legacytelecom.net.br/central_assinante_web/login'
                  className='text-orange-400 hover:text-orange-300 transition-colors cursor-pointer'
                >
                  <i className='ri-user-line mr-2'></i>
                  Portal do Assinante
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className='border-t border-gray-800 pt-8'>
          <div className='flex flex-col md:flex-row justify-between items-center'>
            <div className='text-gray-400 text-sm mb-4 md:mb-0'>
              <p className='mb-1'>
                LGC Telecom LTDA - CNPJ: 54.334.285/0001-26
              </p>
              <p>
                TELEFONE - (65)4042-0692 - EMAIL: suporte@legacytelecom.net.br
              </p>
            </div>
            <div className='text-gray-400 text-sm'>
              <a
                href='https://readdy.ai/?origin=logo'
                className='hover:text-orange-400 transition-colors cursor-pointer'
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
